import { createContext, useState, useCallback } from 'react';
import { PaymentMethod, PaymentInformation } from '../types';

type StepperContextType = {
  activeStepContext: {
    activeStep: number;
    setActiveStep: (step: number) => void;
  };
  paymentMethodContext: {
    paymentMethod?: PaymentMethod;
    setPaymentMethod: (method: PaymentMethod | undefined) => void;
  };
  paymentInformationContext: {
    paymentInformation: PaymentInformation;
    setPaymentInformation: (info: PaymentInformation) => void;
  };
  resetStepper: (step: number) => void;
};

const StepperContext = createContext<StepperContextType>({
  activeStepContext: { activeStep: -1, setActiveStep: () => {} },
  paymentMethodContext: { paymentMethod: undefined, setPaymentMethod: () => {} },
  paymentInformationContext: { paymentInformation: { okay: false }, setPaymentInformation: () => {} },
  resetStepper: () => {},
});

const StepperProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const [activeStep, setActiveStep] = useState(-1);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>();
  const [paymentInformation, setPaymentInformation] = useState<PaymentInformation>({ okay: false });

  const resetStepper = useCallback(
    (step: number = -1) => {
      setActiveStep(step);
      setPaymentMethod(undefined);
      setPaymentInformation({ okay: false });
    },
    [setActiveStep, setPaymentMethod, setPaymentInformation]
  );

  return (
    <StepperContext.Provider
      value={{
        activeStepContext: { activeStep, setActiveStep },
        paymentMethodContext: { paymentMethod, setPaymentMethod },
        paymentInformationContext: { paymentInformation, setPaymentInformation },
        resetStepper,
      }}
    >
      {children}
    </StepperContext.Provider>
  );
};
export default StepperContext;
export { StepperProvider };
